module.exports = __webpack_public_path__ + "media/experiential-learning.4b0e973f.mp4";